import React from 'react'

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-800 text-white">
      <div className="container-max">
        <div className="py-12">
          <div className="grid md:grid-cols-4 gap-8">
            {/* Logo y descripción */}
            <div className="md:col-span-2">
              <img
                src="/logos/logo-negro.png"
                alt="Jenny Kids — Ropa para Niños"
                className="h-36 w-36 object-contain mb-4"
              />
              <p className="text-gray-300 mb-6 max-w-md">
                La mejor ropa infantil para tus pequeños. Calidad, estilo y comodidad en cada prenda.
              </p>
              
              {/* Redes sociales */}
              <div className="flex space-x-4">
                <a href="#" className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-verano-primary transition-colors">
                  <span className="text-lg">📘</span>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-verano-primary transition-colors">
                  <span className="text-lg">📷</span>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-verano-primary transition-colors">
                  <span className="text-lg">🐦</span>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-verano-primary transition-colors">
                  <span className="text-lg">📺</span>
                </a>
              </div>
            </div>
            
            {/* Enlaces rápidos */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Enlaces Rápidos</h4>
              <ul className="space-y-2">
                <li><a href="#inicio" className="text-gray-300 hover:text-verano-primary transition-colors">Inicio</a></li>
                <li><a href="#colecciones" className="text-gray-300 hover:text-verano-primary transition-colors">Colecciones</a></li>
                <li><a href="#nosotros" className="text-gray-300 hover:text-verano-primary transition-colors">Nosotros</a></li>
                <li><a href="#catalogo" className="text-gray-300 hover:text-verano-primary transition-colors">Catálogo</a></li>
                <li><a href="#contacto" className="text-gray-300 hover:text-verano-primary transition-colors">Contacto</a></li>
              </ul>
            </div>
            
            {/* Información legal */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Legal</h4>
              <ul className="space-y-2">
                <li><a href="/privacy" className="text-gray-300 hover:text-verano-primary transition-colors">Política de Privacidad</a></li>
                <li><a href="/terms" className="text-gray-300 hover:text-verano-primary transition-colors">Términos y Condiciones</a></li>
              </ul>
            </div>
          </div>
        </div>
        
        {/* Línea divisoria y copyright */}
        <div className="border-t border-gray-700 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 Jenny Kids. Todos los derechos reservados.
            </p>
            <p className="text-gray-400 text-sm mt-2 md:mt-0">
              Desarrollado con ❤️ para las familias colombianas
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer

